import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiClient from "../../config/AppAdmin";

const initialState = {
  isLoading: false,
  error: null,
  itemsList: [],
  items:[]
};

/* ---------------- FETCH ---------------- */
export const fetchItemsList = createAsyncThunk(
  "items/fetchItemsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await ApiClient.get("/joinData");

      // Step 1: safely extract array
      const rawItems = Array.isArray(res.data?.data?.[0])
        ? res.data.data[0]
        : [];

      // Step 2: remove duplicates by sid
      const uniqueItems = [
        ...new Map(rawItems.map((item) => [item.sid, item])).values(),
      ];

      return uniqueItems;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchItems = createAsyncThunk(
  "items/fetchItems",
  async (_, { rejectWithValue }) => {
    try {
      const res = await ApiClient.get("/item");
      // console.log("items",res)
      return Array.isArray(res.data?.allItemsGot) ? res.data.allItemsGot : [];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
/* ---------------- DELETE ---------------- */
export const deleteItem = createAsyncThunk(
  "items/deleteItem",
  async (sid, { rejectWithValue }) => {
    try {
      await ApiClient.delete(`/joinData/${sid}`);
      return sid;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/* ---------------- UPDATE ---------------- */
export const updateItem = createAsyncThunk(
  "items/updateItem",
  async ({ sid, formData }, { rejectWithValue }) => {
    try {
      const res = await ApiClient.patch(`/joinData/${sid}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // 👇 IMPORTANT
      const updatedItem = Array.isArray(res.data.data)
        ? res.data.data[0]
        : res.data.data;
      return { sid, updated: updatedItem };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const itemsSlice = createSlice({
  name: "items",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchItemsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchItemsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.itemsList = action.payload; // ✅ replaces state
      })
      .addCase(fetchItemsList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // items (item_name and category)
      .addCase(fetchItems.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      /* DELETE */
      .addCase(deleteItem.fulfilled, (state, action) => {
        state.itemsList = state.itemsList.filter(
          (item) => item.sid !== action.payload
        );
      })

      /* UPDATE */
      .addCase(updateItem.fulfilled, (state, action) => {
        const { sid, updated } = action.payload;
        state.itemsList = state.itemsList.map((item) =>
          item.sid === sid ? { ...item, ...updated } : item
        );
      });
  },
});

export default itemsSlice.reducer;
